import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function AlcanceToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class AlcanceForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<AlcanceToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.alcanceEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.alcanceEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.alcancePt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(AlcanceForm);
